import { Card } from "antd"
import ExecutionItem from "./ExecutionItem"

export default function RecentAutoExecutions({ recentExecutions }) {
  return (
    <Card
      bordered={false}
      headStyle={{ borderBottom: "1px solid #e5e7eb", padding: "16px 16px 12px 16px" }}
      bodyStyle={{ padding: "16px" }}
      title={<div className="text-sm">RECENT EXECUTIONS</div>}
      className="w-full"
    >
      <div className="flex flex-col pr-2">
        {recentExecutions.map((execution) => (
          <ExecutionItem key={execution.id} {...execution} />
        ))}
      </div>
    </Card>
  )
}
